class AppContentManager {
  // AppContentManager manages cached app content, including
  // saving and restoring content from local storage.

  constructor (content) {
    if (typeof content === 'object' && content !== null) {
      this.content = content
    } else {
      this.content = {}
    }
  }

  getContent (key, locale = 'en') {
    // getContent fetches the stored content for a given key and locale.
    // Returns the content or an empty string if the key or locale is invalid.

    const item = this.content[key] || {}
    const { contentItemText = {} } = item
    const { content = '' } = contentItemText[locale] || {}

    return content
  }

  static APP_CONTENT_LOCAL_STORAGE_KEY = 'appContent'

  static appContentFromResponse (response) {
    // appContentFromResponse reduces the items in the response array into
    // an object keyed by the items' `key` properties.
    // The text items within each items are reduced into an object keyed
    // by locale for faster lookups.

    if (Array.isArray(response)) {
      return response.reduce((content, value) => {
        const { contentItemText = [] } = value

        const newValue = {
          ...value,
          contentItemText: contentItemText.reduce((items, item) => {
            return { ...items, [item.locale]: item }
          }, {})
        }

        return { ...content, [value.key]: newValue }
      }, {})
    }

    return {}
  }

  static saveAppContent (appContent) {
    try {
      const value = JSON.stringify(appContent)
      window.localStorage.setItem(AppContentManager.APP_CONTENT_LOCAL_STORAGE_KEY, value)
    } catch (e) {
      console.error(`AppContentManager failed to save app content with error: ${e}`)
    }
  }

  static restoreAppContent () {
    const value = window.localStorage.getItem(AppContentManager.APP_CONTENT_LOCAL_STORAGE_KEY)

    if (value) {
      try {
        return JSON.parse(value)
      } catch (e) {
        console.error(`AppContentManager failed to restore app content with error: ${e}`)
      }
    }

    return {}
  }
}

export default AppContentManager



// WEBPACK FOOTER //
// ./src/util/AppContentManager.js